import { Bar } from 'react-chartjs-2';
import { round, baseBarOptions, CHART_COLORS } from '../../../config/chart-config';

const VitaminsChart = ({ labels, values, percentage, rdi, rdi_a_day, tooltip, units }) => {
    if (!percentage?.length) return null;

    const data = {
        labels,
        datasets: [
            {
                data: percentage,
                id: 'labels',
                label: 'RDI, ditt rekommenderade dagliga intag',
                backgroundColor: CHART_COLORS.blue
            },
            {
                data: new Array(labels.length).fill(100),
                type: 'line',
                label: 'RDI',
                id: 'baseline',
                borderColor: CHART_COLORS.green,
                borderWidth: 2,
                fill: false,
                tension: 0.3
            }
        ]
    };

    const options = {
        ...baseBarOptions,
        plugins: {
            legend: { display: false },
            tooltip: {
                filter: (item) => item.dataset.id === 'labels',
                displayColors: false,
                callbacks: {
                    label: function (context) {
                        const index = context.dataIndex;
                        const label = labels[index];
                        const percent = percentage[index];
                        const value = values[index].toFixed(2);
                        const unit = units[index];
                        const r = rdi[index];
                        const r_a_day = rdi_a_day[index];
                        const t = tooltip[index]
                            .replace('[value]', value)
                            .replace('[rdi]', r)
                            .replaceAll('[unit]', unit);
                        return `${t}`;
                    }
                }
            }
        },
        scales: {
            x: { ticks: { autoSkip: false, maxRotation: 90, minRotation: 45 } },
            y: {
                suggestedMax: 160,
                beginAtZero: true,
                title: { display: true, text: 'RDI %' }
            }
        },
        interaction: { mode: 'index' }
    };

    return (
        <div className="chart-wrapper">
            <span>Vitaminer och mineraler</span>
            <div className="chart-inner">
                <Bar data={data} options={options} />
            </div>
        </div>
    );
};

export default VitaminsChart;
